module.exports = __webpack_public_path__ + "static/VS_icon02-01-cbf21b342c5d093f8fa314bf8fba9564.png";